import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, createStyles } from '@material-ui/core';

import { Typography, Variant } from '../../../styles';
import {
    IResumeOffre,
    isVariableProtege,
    isVariableReduit
} from '../../../hooks';

const useStyles = makeStyles(() =>
    createStyles({
        noteInteret: {
            marginLeft: '0.5rem'
        },
        noteInteretSimplifie: {
            fontSize: '14px'
        }
    })
);

export interface INoteTauxInteret {
    isSimplifie: boolean;
    resumeOffre: IResumeOffre;
    hideMarginBottom?: boolean;
}

export const NoteTauxInteret: React.FC<INoteTauxInteret> = ({
    isSimplifie,
    resumeOffre,
    hideMarginBottom = false
}) => {
    const classes = useStyles();
    const [t] = useTranslation(['ResumePret']);

    const { offreChoisie } = resumeOffre;
    const {
        valeurTauxPlafond,
        valeurTauxPreferentiel,
        valeurTauxEcart,
        has5Dans1Note
    } = offreChoisie;

    const isOfferVariableProtege = isVariableProtege(offreChoisie);
    const isOfferVariableReduit = isVariableReduit(offreChoisie);

    return (
        <Typography
            variant={Variant.p}
            className={
                isSimplifie ? classes.noteInteretSimplifie : classes.noteInteret
            }
            hideMarginBottom={hideMarginBottom}
        >
            {has5Dans1Note && (
                <span data-testid="text_taux_5dans1">
                    {/* Ajout du space pour espacement entre interet et tooltip*/}{' '}
                    {t('resumePretInterestSubTextPart1')}
                    <sup>{t('resumePretInterestSubTextPart2')}</sup>
                    {t('resumePretInterestSubTextPart3')}
                </span>
            )}
            {isOfferVariableProtege && valeurTauxPlafond && (
                <span data-testid="text_taux_vp">
                    {t('resumePretTypeVPTextPart1')}
                    {t('Number:percent', {
                        value: valeurTauxPlafond
                    })}
                    {t('resumePretTypeVPTextPart2')}
                </span>
            )}
            {isOfferVariableReduit && valeurTauxPreferentiel && (
                <span data-testid="text_taux_reduit">
                    {t('resumePretTypeVRTextPart1')}
                    {t('Number:percent', {
                        value: valeurTauxPreferentiel
                    })}
                    {valeurTauxEcart >= 0 ? ' +' : ' -'}
                    {t('resumePretTypeVRTextPart2')}
                    {t('Number:percent', {
                        value: Math.abs(valeurTauxEcart)
                    })}
                    {t('resumePretTypeVRTextPart3')}
                </span>
            )}
        </Typography>
    );
};
